"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BackendStore = void 0;
const Server_1 = require("lincd-server-utils/lib/utils/Server");
const package_1 = require("../../package");
const lincd_server_1 = require("../../ontologies/lincd-server");
const InMemoryStore_1 = require("lincd-storage/lib/shapes/InMemoryStore");
/**
 * Abstract class that makes it easier to create a store for the frontend
 * Which loads all its contents on initialisation and passes all the changes
 * to a provider on the backend
 */
let BackendStore = class BackendStore extends InMemoryStore_1.InMemoryStore {
    update(toAdd, toRemove) {
        return super.update(toAdd, toRemove).then(() => {
            //here we manually use convertQuadSetToData, because we want to maintain knowledge of which graph the quads are removed from
            // return Server.call(this, 'update', toAdd, JSONWriter.convertQuadSetToData(toRemove)).then((res) => {
            return Server_1.Server.call(this, 'update', toAdd, toRemove).then((res) => {
                return res;
            });
        });
    }
    // setURIs(...nodes: NamedNode[]): Promise<any> {
    setURIs(nodeToCurrentUriMap) {
        //we need to send over a list of current URI's (as strings), because the backend will use different temporary URI's in its own context
        //if we simply send over nodes
        // let nodeUriMap = nodeToCurrentUriMap.map((currentUri,node) => {
        //   return [node, node.uri];
        // });
        return Server_1.Server.call(this, 'setURIs', nodeToCurrentUriMap);
        // .then((uris: [string, string][]) => {
        //   uris.forEach(([oldURI, newURI]) => {
        //     let node = NamedNode.getOrCreate(oldURI);
        //     node.uri = newURI;
        //   });
        //   return uris;
        // });
    }
    clearProperties(subjectToPredicates) {
        return super.clearProperties(subjectToPredicates).then(() => {
            return Server_1.Server.call(this, 'clearProperties', subjectToPredicates);
        });
    }
    add(quad) {
        return super.add(quad).then(() => {
            return Server_1.Server.call(this, 'add', quad);
        });
    }
    addMultiple(quads) {
        return super.addMultiple(quads).then(() => {
            return Server_1.Server.call(this, 'addMultiple', quads);
        });
    }
    delete(quad) {
        return super.delete(quad).then(() => {
            return Server_1.Server.call(this, 'delete', quad);
        });
    }
    deleteMultiple(quads) {
        return super.deleteMultiple(quads).then(() => {
            return Server_1.Server.call(this, 'deleteMultiple', quads);
        });
    }
    removeNodes(nodes) {
        return super.removeNodes(nodes).then(() => {
            return Server_1.Server.call(this, 'removeNodes', nodes);
        });
    }
};
exports.BackendStore = BackendStore;
BackendStore.targetClass = lincd_server_1.lincdServer.BackendStore;
exports.BackendStore = BackendStore = __decorate([
    package_1.linkedShape
], BackendStore);
//# sourceMappingURL=BackendStore.js.map